import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Navimumbaiairportcabservice() {



const cardData = {
  keyword: " Navi Mumbai Airport Cab Service",

headingDescription:
  "Omshree Cab offers reliable and comfortable Navi Mumbai Airport cab services for travelers who need convenient transportation to and from Navi Mumbai International Airport. Whether you are traveling for business, family trips, vacations, or corporate meetings, our airport cab service ensures timely pickups, smooth travel, and a stress-free journey. We provide flexible booking options including airport pickup, airport drop, one-way transfers, round-trip bookings, and hourly packages with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With experienced chauffeurs who understand airport schedules and city traffic, punctual pickups from homes, hotels, offices, or railway stations, and 24/7 customer support, Omshree Cab is your trusted partner for dependable Navi Mumbai Airport cab services.",

topPlaces: [
  {
    title: "Central Park Kharghar",
    description:
      "Central Park in Kharghar is one of the largest and most beautiful urban parks in Navi Mumbai. The park features wide walking paths, landscaped gardens, fountains, and open recreational areas where families and visitors can relax and enjoy nature. Many people visit the park for morning walks, jogging, picnics, and photography. The peaceful surroundings and greenery provide a refreshing escape from city traffic and busy streets. Travelers using a Navi Mumbai Airport cab service can easily visit Central Park after arriving in the city or before heading to the airport for a relaxing outing."
  },
  {
    title: "Pandavkada Waterfalls",
    description:
      "Pandavkada Waterfalls is a popular natural attraction located near Kharghar in Navi Mumbai. Surrounded by hills and lush greenery, the waterfall becomes especially beautiful during the monsoon season when water cascades down the rocky cliffs. Visitors often come here for nature walks, photography, and enjoying the cool fresh air of the surrounding forest area. The peaceful environment makes it a perfect destination for short trips and weekend outings. Booking a cab from Navi Mumbai Airport allows travelers to comfortably visit this scenic natural location."
  },
  {
    title: "DY Patil Stadium",
    description:
      "DY Patil Stadium is one of the most modern sports and entertainment venues in Navi Mumbai. The stadium hosts international cricket matches, football games, concerts, and large cultural events. Its impressive architecture and modern facilities attract sports fans and tourists throughout the year. Visitors attending an event can conveniently reach the stadium using a cab from Navi Mumbai Airport without worrying about navigation or traffic."
  },
  {
    title: "Seawoods Grand Central Mall",
    description:
      "Seawoods Grand Central Mall is a large shopping and entertainment destination in Navi Mumbai featuring international brands, restaurants, cafes, movie theaters, and family entertainment areas. Visitors can enjoy shopping, dining, and leisure activities all in one place. The mall is connected to the Seawoods railway station and is one of the most popular lifestyle hubs in the region. A cab ride from Navi Mumbai Airport makes it easy for travelers to reach this shopping destination comfortably."
  },
  {
    title: "Belapur Fort",
    description:
      "Belapur Fort is a historic structure built centuries ago and located in Navi Mumbai near CBD Belapur. The fort once served as a strategic defense point and now stands as an interesting historical attraction surrounded by greenery. Visitors can explore the old walls, enjoy scenic surroundings, and learn about the region’s history. A comfortable cab journey from Navi Mumbai Airport allows travelers to include this historical landmark in their sightseeing plans."
  },
  {
    title: "Palm Beach Road",
    description:
      "Palm Beach Road is one of the most scenic and well-planned roads in Navi Mumbai, stretching along the coastline and connecting major areas of the city. The wide road offers beautiful views of water bodies, skyline landscapes, and modern residential complexes. Many people enjoy evening drives along this road because of its smooth traffic flow and picturesque surroundings. Hiring a cab from Navi Mumbai Airport allows travelers to enjoy a comfortable and relaxing drive along Palm Beach Road."
  },
  {
    title: "Utsav Chowk",
    description:
      "Utsav Chowk is a famous landmark located in Kharghar known for its unique architecture and beautiful fountains. The area around the chowk has cafes, restaurants, and shopping options where visitors can spend leisure time. It is a popular place for evening outings and photography due to its well-designed urban landscape. Travelers using a Navi Mumbai Airport cab service can conveniently visit this vibrant location while exploring the city."
  },
  {
    title: "Kharghar Hills",
    description:
      "Kharghar Hills are a scenic natural area offering panoramic views of Navi Mumbai and the surrounding landscapes. Adventure enthusiasts and nature lovers visit the hills for trekking, hiking, and photography. The peaceful environment and cool breeze make it a refreshing destination away from busy urban areas. A cab ride from Navi Mumbai Airport provides easy access to this natural attraction for travelers looking to explore the region."
  },
  {
    title: "Nerul Balaji Temple",
    description:
      "Nerul Balaji Temple is a beautiful temple dedicated to Lord Venkateswara and is designed in traditional South Indian architectural style. The temple attracts devotees and tourists who come to offer prayers and admire its intricate carvings and peaceful surroundings. Located in Nerul, it is one of the most visited religious sites in Navi Mumbai. Booking a cab from Navi Mumbai Airport allows devotees to comfortably reach the temple for darshan."
  },
  {
    title: "Sagar Vihar",
    description:
      "Sagar Vihar is a peaceful waterfront promenade located in Vashi overlooking the Thane Creek. The area is popular for evening walks, photography, and enjoying the cool breeze from the water. Families and tourists visit to relax while watching beautiful sunset views across the creek. A cab service from Navi Mumbai Airport ensures convenient access to this relaxing waterfront destination."
  }
],



services: [
{
name: "Navi Mumbai Airport Cab Service",
description: "Navi Mumbai airport cab service provides reliable and comfortable transportation for passengers traveling to and from Navi Mumbai International Airport. Our fleet includes well-maintained AC sedans, SUVs, and premium vehicles designed for smooth airport transfers. Professional drivers ensure punctual pickup and safe driving across Mumbai and Navi Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and business districts. Spacious seating and luggage space ensure convenient travel for families and corporate travelers. Ideal for domestic and international airport transfers. Transparent pricing and professional service make your airport journey comfortable and stress-free."
},
{
name: "Navi Mumbai Airport Taxi Service",
description: "Navi Mumbai airport taxi service offers dependable transportation for passengers needing timely airport transfers. Our vehicles provide comfortable seating and smooth ride quality suitable for city travel. Professional drivers monitor flight schedules to ensure timely pickup and drop services. Pickup is available from homes, hotels, offices, railway stations, and major business hubs across Mumbai and Navi Mumbai. Air-conditioned vehicles ensure relaxed travel even during traffic hours. Ideal for corporate travelers, tourists, and family airport journeys. Flexible booking options allow convenient travel planning."
},
{
name: "Cab Service for Navi Mumbai Airport",
description: "Cab service for Navi Mumbai airport provides safe and convenient transportation for passengers traveling to the airport. Vehicles are clean, comfortable, and equipped with sufficient luggage space for airport travel. Professional drivers ensure punctual pickup services so passengers reach the airport on time. Pickup is available from homes, offices, hotels, railway stations, and city locations. Air-conditioned vehicles ensure comfortable travel during the journey. Ideal for family airport trips, business travel, and tourism transfers."
},
{
name: "Airport Taxi Navi Mumbai",
description: "Airport taxi Navi Mumbai service offers reliable airport transportation for passengers traveling to or from Navi Mumbai International Airport. Vehicles provide smooth ride performance and comfortable seating suitable for airport transfers. Professional drivers ensure safe driving and punctual pickup services across Mumbai and Navi Mumbai. Pickup is available from homes, hotels, offices, railway stations, and commercial areas. Ideal for domestic and international airport travel. Flexible booking options make travel easy and convenient."
},
{
name: "Navi Mumbai Airport Pickup Taxi",
description: "Navi Mumbai airport pickup taxi service provides dependable transportation for passengers arriving at the airport. Drivers track flight arrival timings to ensure timely pickup even if flights are delayed. Vehicles provide comfortable seating and sufficient luggage space for travelers. Pickup services are available for hotels, homes, and business locations across Mumbai and Navi Mumbai. Ideal for tourists, corporate travelers, and family airport transfers."
},
{
name: "Navi Mumbai Airport Drop Cab",
description: "Navi Mumbai airport drop cab service offers timely transportation for passengers traveling to the airport for departures. Professional drivers ensure punctual pickup services so travelers reach the airport comfortably before flight time. Vehicles offer comfortable seating and air-conditioned interiors for smooth travel. Pickup is available from homes, offices, hotels, and railway stations across Mumbai and Navi Mumbai."
},
{
name: "Navi Mumbai Airport Cab Booking Online",
description: "Navi Mumbai airport cab booking online allows passengers to easily reserve vehicles for airport transfers with quick confirmation. Travelers can schedule rides online and plan convenient airport transportation. Vehicles provide comfortable seating and reliable ride performance suitable for city travel. Professional drivers ensure punctual pickup services across Mumbai and Navi Mumbai."
},
{
name: "Navi Mumbai Airport Taxi Booking",
description: "Navi Mumbai airport taxi booking service provides simple and reliable reservations for passengers traveling to the airport. Booking options include phone and online reservations with quick confirmation. Vehicles provide comfortable seating and smooth ride quality suitable for airport journeys. Professional drivers ensure punctual pickup and safe travel."
},
{
name: "Cheap Navi Mumbai Airport Taxi",
description: "Cheap Navi Mumbai airport taxi service provides affordable airport transportation without compromising safety and comfort. Passengers can travel in clean vehicles with professional drivers at economical pricing. Ideal for budget travelers, students, and daily commuters needing airport transfers. Transparent pricing ensures no hidden charges."
},
{
name: "Best Airport Cab Navi Mumbai",
description: "Best airport cab Navi Mumbai service offers premium and reliable airport transportation for travelers seeking professional service. Vehicles provide spacious seating, smooth ride quality, and comfortable interiors. Professional drivers ensure punctual pickup and safe driving throughout the journey. Ideal for corporate travelers, tourists, and families."
},
{
name: "Luxury Airport Cab Navi Mumbai",
description: "Luxury airport cab Navi Mumbai service provides premium vehicles for passengers seeking high-end airport travel. Luxury sedans and SUVs provide superior comfort and spacious seating for a relaxing journey. Professional chauffeurs ensure smooth driving and courteous service throughout the trip."
},
{
name: "Airport Cab Near Me Navi Mumbai",
description: "Airport cab near me Navi Mumbai service allows passengers to quickly find nearby airport transportation when needed. Our network of vehicles ensures quick pickup services from homes, offices, hotels, and commercial areas. Comfortable vehicles and professional drivers ensure reliable airport travel."
},
{
name: "24 Hour Airport Cab Navi Mumbai",
description: "24 hour airport cab Navi Mumbai service provides round-the-clock transportation for passengers traveling at any time of day or night. Whether early morning departures or late-night arrivals, drivers are available to ensure reliable airport transfers."
},
{
name: "Innova Airport Cab Navi Mumbai",
description: "Innova airport cab Navi Mumbai service provides spacious MPV transportation ideal for families and groups traveling with luggage. Toyota Innova vehicles offer comfortable seating and smooth ride quality suitable for airport journeys. Professional drivers ensure punctual pickups and safe travel."
},
{
name: "Sedan Airport Taxi Navi Mumbai",
description: "Sedan airport taxi Navi Mumbai service provides economical and comfortable airport transportation for individual travelers and small families. Sedan vehicles offer smooth ride quality, air-conditioned interiors, and convenient luggage space."
}
],

tableData: [
["Navi Mumbai Airport Cab Service","Navi Mumbai Airport Taxi Service"],
["Cab Service for Navi Mumbai Airport","Airport Taxi Navi Mumbai"],
["Navi Mumbai Airport Pickup Taxi","Navi Mumbai Airport Drop Cab"],
["Navi Mumbai Airport Cab Booking Online","Navi Mumbai Airport Taxi Booking"],
["Cheap Navi Mumbai Airport Taxi","Best Airport Cab Navi Mumbai"],
["Luxury Airport Cab Navi Mumbai","Airport Cab Near Me Navi Mumbai"],
["24 Hour Airport Cab Navi Mumbai","Innova Airport Cab Navi Mumbai"],
["Sedan Airport Taxi Navi Mumbai","Airport Transfer Navi Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Professional Airport Transfer Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in airport transportation across Navi Mumbai and surrounding regions. They are familiar with airport routes, terminal entry points, and traffic conditions ensuring timely pickup and drop services."
  },
  {
    WhyChooseheading: "Transparent Airport Cab Pricing",
    WhyChoosedescription: "Omshree Cabs offers transparent pricing for Navi Mumbai Airport cab service. Customers receive clear information about per-kilometer fares, toll charges, and waiting charges before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Airport Cab Availability",
    WhyChoosedescription: "Our Navi Mumbai Airport cab service operates 24 hours a day to match all flight schedules. Whether you have an early morning departure or a late-night arrival, our cabs are available anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in our fleet are well maintained, fully air-conditioned, and regularly cleaned to provide a comfortable airport travel experience."
  },
  {
    WhyChooseheading: "Flexible Airport Transfer Options",
    WhyChoosedescription: "We offer flexible airport transportation options including airport pickup, airport drop, round-trip transfers, and corporate airport cab services."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and group travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai & Navi Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, offices, hotels, railway stations, and business centers anywhere in Mumbai and Navi Mumbai for smooth airport transfers."
  },
  {
    WhyChooseheading: "Reliable Airport Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by travelers for reliable Navi Mumbai Airport cab service thanks to our punctual drivers, comfortable vehicles, and professional customer support."
  }
]
};

const faqData = [
  { question: "Do you provide cab service to Navi Mumbai Airport?", answer: "Yes, Omshree Cabs provides reliable cab services to and from Navi Mumbai Airport for both pickup and drop." },
  { question: "Is Navi Mumbai Airport cab service available 24 hours?", answer: "Yes, our airport cab service operates 24/7 to match flight arrival and departure timings." },
  { question: "Which vehicles are available for airport travel?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, luxury vehicles like Innova Crysta, and Tempo Travellers based on passenger requirements." },
  { question: "Can I book a cab for airport pickup?", answer: "Yes, we provide airport pickup services where drivers wait at the arrival terminal to receive passengers." },
  { question: "Do you provide airport cab service from Mumbai city?", answer: "Yes, we provide airport transfers from all areas of Mumbai including South Mumbai, Western Suburbs, and Central Suburbs." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable airport travel." },
  { question: "Do drivers track flight schedules?", answer: "Yes, our drivers track flight arrival times to ensure timely pickup even if flights are delayed." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during peak travel hours." },
  { question: "Do you provide corporate airport transfers?", answer: "Yes, we provide airport cab services for corporate travelers and business executives." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to maintain passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Kunal Desai",
    feedback:
      "We booked Omshree Cabs for a Navi Mumbai Airport drop. The driver was punctual and the ride was very comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Shah",
    feedback:
      "Excellent airport cab service. Clean vehicle, polite driver, and smooth transfer to Navi Mumbai Airport.",
    rating: 5
  }
];









































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Navi Mumbai Airport Cab Service",
  "description": "Omshree Cab offers reliable Navi Mumbai Airport cab service for pickups, drops, one-way or round trips. Choose from Innova, sedan, or luxury cabs with 24/7 online booking at affordable prices.",
  "provider": {
    "@type": "Organization",
    "name": "Omshree Cab",
    "telephone": "+91 9892544084",
    "url": "https://www.omshreecab.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Navi Mumbai"
  },
  "serviceType": "Airport Cab Service"
};





  return (
    <div>
      
<Helmet>
  <title>Navi Mumbai Airport Cab Service | 24/7 Pickup & Drop | Omshree Cab</title>
  <meta 
    name="description" 
    content="Book Navi Mumbai Airport cab service with Omshree Cab. Get pickups, drops, one-way or round trips with Innova, sedan, or luxury cabs. Affordable, safe, and 24/7 online booking." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/82.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaiairportcabservice;